import {
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography
} from "@mui/material";
import { useTheme } from "@emotion/react";

const DataTable = ({
  cols,
  data,
  total,
  dataFilter,
  setDataFilter,
  onBatchChange,
  isOnlyTable,
  tableCall,
  isLoading,
  manualColor,
  isStickyHide,
  handleColumn
}) => {
  const { palette } = useTheme();

  return (
    <>
      <TableContainer sx={{ borderRadius: "4px", maxHeight: "calc(100vh - 256px)", position: "relative" }}>
        <Table
          size="small"
          sx={{
            borderCollapse: "inherit"
          }}
        >
          <TableHead
            sx={{
              background: manualColor ? "#bcbaba" : palette.secondary.main,
              position: "sticky",
              top: "0",
              zIndex: "2"
            }}
          >
            <TableRow
              sx={{
                position: "relative"
              }}
            >
              {cols
                ?.filter((x) => !x.hide)
                ?.map((headerItem, index) => (
                  <TableCell
                    key={index}
                    className="sticky-row"
                    sx={{
                      p: 2,
                      minWidth: index === 0 ? "none" : "20px",
                      position: isStickyHide
                        ? "static"
                        : cols.filter((x) => !x.hide).length === index + 1
                        ? "sticky"
                        : "static",
                      right: "0",
                      top: "0",
                      background: palette.mode === "dark" ? palette.secondary.main : palette.white.main
                    }}
                  >
                    <b>{headerItem.title}</b>
                  </TableCell>
                ))}
            </TableRow>
          </TableHead>
          {isLoading ? (
            <TableBody>
              {Array.from(Array(5).keys())?.map((y) => {
                return (
                  <TableRow key={y}>
                    {Array.from(Array(cols?.filter((x) => !x?.hide)?.length)?.keys())?.map((x) => {
                      return (
                        <TableCell key={x}>
                          <Skeleton variant="rectangular" width={"100%"} height={30} />
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          ) : (
            <>
              <TableBody>
                {data?.length > 0 ? (
                  data?.map((item, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        position: "relative",
                        cursor: handleColumn ? "pointer" : "default"
                      }}
                      onClick={() => (handleColumn ? handleColumn(item) : () => {})}
                    >
                      {cols
                        ?.filter((x) => !x.hide)
                        ?.map((col, key) => (
                          <TableCell
                            key={key}
                            className="sticky-row"
                            sx={{
                              position: isStickyHide
                                ? "static"
                                : cols.filter((x) => !x.hide).length === key + 1
                                ? "sticky"
                                : "static",
                              right: "0",
                              top: "0",
                              background: palette.mode === "dark" ? palette.secondary.main : palette.white.main
                            }}
                          >
                            {" "}
                            {col.render(item)}
                          </TableCell>
                        ))}
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={cols?.length} align="center">
                      <Typography variant="h5">Data not available!</Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </>
          )}
        </Table>
      </TableContainer>
      {isOnlyTable ? null : (
        <TablePagination
          className="tablePagination"
          sx={{
            background: palette.mode === "dark" ? palette.secondary.main : palette.white.main
          }}
          component="div"
          count={total !== undefined ? total : 0}
          page={dataFilter.page - 1}
          rowsPerPageOptions={[5, 10, 25, 50, 100]}
          onPageChange={onBatchChange ? onBatchChange : () => {}}
          rowsPerPage={dataFilter.limit}
          onRowsPerPageChange={(e) => setDataFilter({ ...dataFilter, limit: parseInt(e.target.value), page: 1 })}
        />
      )}
    </>
  );
};

export default DataTable;
